import React from 'react';

const euro = (value, signed = false) => {
  const text = `€${Math.abs(Math.round(value)).toLocaleString('en-IE')}`;
  return value < 0 ? `-${text}` : signed && value > 0 ? `+${text}` : text;
};

const shortDate = (value) => {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleDateString('en-IE', { day: 'numeric', month: 'short', year: 'numeric' });
};

const details = (l) =>
  [l.bedrooms != null ? `${l.bedrooms} bed` : null, l.bathrooms != null ? `${l.bathrooms} bath` : null, l.sqm != null ? `${l.sqm} m²` : null]
    .filter(Boolean)
    .join(' · ');

// Compact summary shared by the map popups and the side panel cards
export default function ListingInfo({ listing }) {
  return (
    <div className="listing-info">
      <div className="listing-line listing-price">
        {listing.price != null ? euro(listing.price) : 'POA'}
        {listing.ber_rating ? <span className="listing-muted"> · BER {listing.ber_rating}</span> : null}
      </div>
      <div className="listing-line">{details(listing)}</div>
      <div className="listing-line listing-muted">
        {[listing.location, listing.date_listed ? `Listed ${shortDate(listing.date_listed)}` : null].filter(Boolean).join(' · ')}
      </div>
      {listing.price_sold != null && (
        <dl className="listing-sold">
          <dt>Sold</dt>
          <dd>{euro(listing.price_sold)}</dd>
          {listing.price_difference != null && (
            <>
              <dt>Uplift</dt>
              <dd className={listing.price_difference < 0 ? 'negative-value' : 'positive-value'}>
                {euro(listing.price_difference, true)}
                {listing.price_difference_pct != null ? ` (${listing.price_difference_pct > 0 ? '+' : ''}${listing.price_difference_pct}%)` : ''}
              </dd>
            </>
          )}
          {listing.time_on_market && (
            <>
              <dt>On market</dt>
              <dd>{listing.time_on_market}</dd>
            </>
          )}
        </dl>
      )}
    </div>
  );
}
